window.coreHelpers = window.coreHelpers || {};

window.coreHelpers = {};

/**
 * ajax helper function for use with WP ajax actions
 * https://api.jquery.com/jquery.ajax/
 *
 * NOTE: to use 'this' in callbacks, 'this' must be bound to the coreHelpers.ajax by using window.coreHelpers.ajax.call(this, ...
 *
 * @param  {string} method='GET'
 * @param  {string} action=false //this is used to trigger a WP ajax action
 * @param  {object} data=false //this is the data passed to the WP ajax action
 * @param  {function} successCallback=coreHelpers.ajaxSuccessCallback
 * @param  {function} errorCallback=coreHelpers.ajaxFailureCallback
 * @param  {string} dataType='json'
 * @param  {boolean} cache=true
 * @param  {string} url=coreVariables.ajaxUrl
 */

coreHelpers.ajax = function(method = 'GET', action = false, data = false, successCallback = coreHelpers.ajaxSuccessCallback, errorCallback = coreHelpers.ajaxFailureCallback, dataType = 'json', cache = true, url = coreVariables.ajaxUrl) {

    if (action) {

        let ajaxData;

        if(data) {

            ajaxData = data;

        }
        else {

            ajaxData = {};

        }

        let settings = {

            method: method,

            url: url,

            data: ajaxData,

            dataType: dataType,

            cache: cache,

            context: this, //determines the scope in the callbacks

        }

        //add the action
        ajaxData.action = action;
        ajaxData.security = coreVariables.ajaxNonce;

        jQuery.ajax(settings).done(function(res) {

            if(coreHelpers.ajaxHandleResponse(res)){

                if (successCallback) {

                    console.log('CORE: ajax success, firing callback...', res);
                    successCallback.call(this, res);

                }

            }
            else {

                if (errorCallback) {

                    console.log('CORE: ajax error, firing callback...', res);
                    errorCallback.call(this, res);

                }
            }

        }).fail(function(req = false, status = false, error = false) {

            if (errorCallback) {

                console.log('CORE: ajax responded with an error, firing callback...', req, status, error);
                errorCallback.call(this, req, status, error);

            }
            else {

                console.log('CORE: ajax responded with an error', req, status, error);

            }

        });

    } else {

        console.log('CORE: args missing for coreHelpers.ajax', res);

        if (errorCallback) {

            errorCallback(null, null, 'args missing for coreHelpers.ajax');

        }

    }

}

//these functions can be redefined by the child theme
coreHelpers.ajaxSuccessCallback = function(res) {

    console.log('CORE: ajax success callback fired');

}
coreHelpers.ajaxFailureCallback = function(res) {

    console.log('CORE: ajax failure callback fired');

}

/**
 * handle the response sent by wp_send_json_success / wp_send_json_error
 * @param {object} res
 */
coreHelpers.ajaxHandleResponse = function(res){

    if(res.success === true) {

        return true;

    }
    else if(res.success === false) {

        return false;
    }

    return true;

}

/**
 * get a nested object in js without triggering errors
 * https://stackoverflow.com/questions/2631001/test-for-existence-of-nested-javascript-object-key
 * @param  {object} obj
 * @param  {args} ...args
 * usage: coreHelpers.getNested('level1', 'level2', 'level3')
 */
coreHelpers.getNested = function(obj, ...args) {

    let result = args.reduce((obj, level) => obj && obj[level], obj)

    return typeof result !== 'undefined' ? result : false;
}